import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const AVATAR_URL = 'https://i.ibb.co/60cRjycV/pana-886777-img-only.jpg';

const LoginScreen = ({ onUnlock }) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        onUnlock();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onUnlock]);

  const timeString = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  const dateString = now.toLocaleDateString([], {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });

  return (
    <div
      className="fixed inset-0 w-full h-full overflow-hidden font-os text-os-text select-none"
      style={{ background: 'linear-gradient(160deg, #1b2340 0%, #2a1b4a 45%, #0b0d14 100%)' }}
    >
      <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-os-accent/10 blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[28rem] h-[28rem] rounded-full bg-purple-500/10 blur-3xl pointer-events-none" />

      <div className="relative w-full h-full flex flex-col items-center justify-center px-6">
        <motion.div
          initial={{ opacity: 0, y: -12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="flex flex-col items-center mb-10"
        >
          <div className="text-7xl sm:text-8xl font-extralight tracking-tight leading-none tabular-nums">
            {timeString}
          </div>
          <div className="mt-2 text-base sm:text-lg text-os-textdim font-light">
            {dateString}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16, scale: 0.97 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.15, ease: 'easeOut' }}
          onClick={onUnlock}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') onUnlock();
          }}
          className="flex flex-col items-center cursor-pointer group focus:outline-none"
        >
          <div className="relative">
            <img
              src={AVATAR_URL}
              alt="Sam Togun"
              className="w-28 h-28 rounded-full object-cover border-4 border-white/10 shadow-[0_8px_30px_rgba(0,0,0,0.5)] group-hover:border-os-accent/40 transition-colors duration-300"
            />
            <div className="absolute inset-0 rounded-full ring-1 ring-white/10" />
          </div>

          <div className="mt-4 text-xl font-medium">Sam Togun</div>
          <div className="mt-1 text-sm text-os-textdim">Senior Backend Engineer &amp; Solutions Architect</div>

          <div className="mt-6 flex items-center gap-2">
            {Array.from({ length: 8 }).map((_, i) => (
              <span
                key={i}
                className="w-2 h-2 rounded-full bg-white/15 border border-white/20 group-hover:bg-white/25 transition-colors duration-300"
              />
            ))}
          </div>

          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onUnlock();
            }}
            className="mt-6 flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/10 hover:bg-os-accent/90 border border-white/10 backdrop-blur-md text-sm font-medium text-os-text transition-colors duration-200 shadow-[0_4px_20px_rgba(0,0,0,0.35)]"
          >
            <span>Enter</span>
            <i className="fa-solid fa-arrow-right-to-bracket text-xs" />
          </button>

          <div className="mt-4 text-xs text-os-textdim/70 tracking-wide">
            Click anywhere on the card or press{' '}
            <kbd className="px-1.5 py-0.5 rounded bg-white/10 border border-white/10 font-sans">Enter</kbd>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default LoginScreen;
